// src/context/ConfirmProvider.jsx
import { useCallback, useState } from "react";
import { ConfirmContext } from "./ConfirmContext";
import { ConfirmDialog } from "../components/ConfirmDialog";

export const ConfirmProvider = ({ children }) => {
  const [state, setState] = useState(null);

  const confirm = useCallback(
    (options = {}) =>
      new Promise((resolve) => {
        setState({ mode: "confirm", resolve, ...options });
      }),
    [],
  );

  const prompt = useCallback(
    (options = {}) =>
      new Promise((resolve) => {
        setState({ mode: "prompt", resolve, ...options });
      }),
    [],
  );

  const close = (result) => {
    state?.resolve(result);
    setState(null);
  };

  return (
    <ConfirmContext.Provider value={{ confirm, prompt }}>
      {children}
      {state && (
        <ConfirmDialog
          state={state}
          onCancel={() => close(state.mode === "prompt" ? null : false)}
          onSubmit={(value) => close(state.mode === "prompt" ? value : true)}
        />
      )}
    </ConfirmContext.Provider>
  );
};
